/**
 * @generated SignedSource<<b4eea4200b201b41b1189d04a2be9847>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FooterCreateButtons_space$data = {
  readonly alias: string | null;
  readonly didContainUserContent: boolean;
  readonly id: string | null;
  readonly key: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly spaceTypeSettings: {
    readonly enabledContentTypes: {
      readonly isDatabasesEnabled: boolean;
      readonly isLivePagesEnabled: boolean;
      readonly isWhiteboardsEnabled: boolean;
    };
  };
  readonly " $fragmentType": "FooterCreateButtons_space";
};
export type FooterCreateButtons_space$key = {
  readonly " $data"?: FooterCreateButtons_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"FooterCreateButtons_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FooterCreateButtons_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledContentTypes",
          "kind": "LinkedField",
          "name": "enabledContentTypes",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isLivePagesEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isWhiteboardsEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isDatabasesEnabled"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "didContainUserContent"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "910111d858272681ebc5c4d1e2d1e204";

export default node;
